import React from 'react';
import { useRouter } from 'next/router';
import { Formik } from 'formik';

import { formatTimeframe } from '@/hooks/calendar_helpers';
import ToggleForm from '@/components/forms/toggle_form';
import routes from '@/services/routes';
import Button, { ButtonSize, ButtonType } from '@/components/commons/button';
import Container, { ContainerTypes } from '@/components/commons/page-elements/Container';

import EnvelopeOutline from '@/components/commons/icons/EnvelopeOutline';
import PenOutline from '@/components/commons/icons/PenOutline';

function injectImage({
    dayOfTheWeek, window, hour, startNextDay,
}) {
    const startOfWeekSchedule = (dayOfTheWeek === 0 && !!startNextDay)
        || (dayOfTheWeek === 1 && !startNextDay);
    let graphic = '/images/icon-grin.svg';
    let alt = 'icon-grin';
    if (dayOfTheWeek === null && hour < 12) {
        graphic = '/images/icon-sun.svg';
        alt = 'icon-sun';
    } else if (dayOfTheWeek === null && hour >= 18) {
        graphic = '/images/icon-moon.svg';
        alt = 'icon-moon';
    } else if (startOfWeekSchedule && (window === null || window === 7)) {
        graphic = '/images/icon-calendar-weekly.svg';
        alt = 'icon-calendar';
    }
    return <img src={graphic} alt={alt} className="pt-5 pb-3 w-auto" />;
}

export default function AgendasCard({
    record,
    vacationMode,
    externalStyles,
    handleUpdateAgenda,
    handleSendExistingAgendaMail,
    onboardingData,
    user,
}) {
    const router = useRouter();
    const fieldName = `enabled-${record.id}`;
    const centered = 'flex justify-center items-center flex-col sm:flex-row w-full sm:w-auto';

    return (
        <Container type={ContainerTypes.WHITE} externalStyles={externalStyles}>
            <div data-onboarding={record.id === onboardingData.agendaAddEdit.id ? 'agenda-step-4' : ''}>
                {injectImage(record)}
            </div>
            <Button
                type={ButtonType.plain}
                title={record.name}
                externalStyles="text-lg font-bold p-0"
                onClick={() => router.push({
                    pathname: routes.EDIT_AGENDA,
                    query: { id: record.id },
                })}
                text={record.name}
            />
            <div className="text-[14px]">
                {formatTimeframe(user, record)}
            </div>
            <div className={`${centered} py-9 font-medium text-cleanSlate`}>
                {!vacationMode
                    ? (
                        <>
                            <Formik
                                onSubmit={() => { }}
                                initialValues={{
                                    field: !!record.enabled,
                                }}
                            >
                                <ToggleForm
                                    record={record}
                                    onChange={handleUpdateAgenda}
                                    fieldName={fieldName}
                                    propertyName="enabled"
                                />
                            </Formik>
                            {record.enabled ? 'Enabled' : 'Disabled'}
                        </>
                    )
                    : 'Vacation Mode Is On'}
            </div>
            <div className={`${centered} gap-3`}>
                <Button
                    tip="tip"
                    tipContent="Send Now"
                    title="Send now"
                    size={ButtonSize.base}
                    type={ButtonType.secondary}
                    text="Send now"
                    icon={<EnvelopeOutline className="w-3 h-3 dark:text-cirrusWhite" />}
                    onClick={() => handleSendExistingAgendaMail(record.id)}
                />
                <Button
                    tip="tip"
                    tipContent="Edit this Agenda"
                    title="Edit this Agenda"
                    externalStyles="px-3 py-2"
                    text="Edit"
                    icon={<PenOutline className="w-3 h-3 dark:text-cirrusWhite" />}
                    onClick={() => router.push({
                        pathname: routes.EDIT_AGENDA,
                        query: { id: record.id },
                    })}
                />
            </div>
        </Container>
    );
}
